import "../../styles/all.css"
import './footer.css';
import { useTranslation } from "react-i18next";

function Footer() {
        const { t } = useTranslation();
  
  return (
<footer className="inote-footer">
  <div className="inote-container">
    <div className="inote-footer-grid">
      {/* Company Section */}
      <div className="inote-footer-section">
        <h2 className="inote-logo">iNote Tech</h2>
        <p className="inote-description">
          {t("footer_company_description")}
        </p>
        <div className="inote-social-icons">
          <a href="#" className="inote-social-icon">
            <i className="fa-brands fa-facebook"></i>
          </a>
          <a href="#" className="inote-social-icon">
            <i className="fa-brands fa-twitter"></i>
          </a>
          <a href="#" className="inote-social-icon">
            <i className="fa-brands fa-instagram"></i>
          </a>
          <a href="#" className="inote-social-icon">
            <i className="fa-brands fa-linkedin"></i>
          </a>
        </div>
      </div>

      {/* Quick Links */}
      <div className="inote-footer-section">
        <h3>{t("footer_quick_links")}</h3>
        <ul>
          <li><a href="#">{t("footer_about_us")}</a></li>
          <li><a href="#">{t("footer_services")}</a></li>
          <li><a href="#">{t("footer_products")}</a></li>
          <li><a href="#">{t("footer_contact")}</a></li>
          <li><a href="#">{t("footer_careers")}</a></li>
        </ul>
      </div>

      {/* Support */}
      <div className="inote-footer-section">
        <h3>{t("footer_support")}</h3>
        <ul>
          <li><a href="#">{t("footer_faq")}</a></li>
          <li><a href="#">{t("footer_help_center")}</a></li>
          <li><a href="#">{t("footer_privacy_policy")}</a></li>
          <li><a href="#">{t("footer_terms_of_service")}</a></li>
          <li><a href="#">{t("footer_contact_support")}</a></li>
        </ul>
      </div>

      {/* Newsletter */}
      <div className="inote-footer-section">
        <h3>{t("footer_newsletter")}</h3>
        <p className="inote-newsletter-text">
          {t("footer_newsletter_text")}
        </p>
        <form className="inote-newsletter-form">
          <input 
            type="email" 
            placeholder={t("footer_enter_email")} 
            required 
          />
          <button type="submit">
            <span>→</span>
          </button>
        </form>
      </div>
    </div>

    {/* Footer Bottom */}
    <div className="inote-footer-bottom">
      <div className="inote-bottom-links">
        <a href="#">{t("footer_privacy_policy")}</a> | 
        <a href="#">{t("footer_terms_of_service")}</a> | 
        <a href="#">{t("footer_cookie_policy")}</a>
      </div>
      <p className="inote-copyright">
        © {new Date().getFullYear()} {t("footer_copyright")}
      </p>
    </div>
  </div>
</footer>
   
  );
}

export default Footer;